module.exports = __webpack_public_path__ + "media/components/assets/img/bg/airport-lp-f068c2d088df94580c011e2f4b76f184.svg";